export const ACTIVE_PLATFORM = 'ACTIVE_PLATFORM'
export const DESACTIVE_PLATFORM = 'DESACTIVE_PLATFORM'
